(() => {
  document.querySelectorAll('[data-tis-collection-controls]').forEach((root) => {
    const dialog = root.querySelector('[data-tis-filter-dialog]');
    const filterTrigger = root.querySelector('[data-tis-filter-open]');
    const form = root.querySelector('[data-tis-filter-form]');
    const sortMenu = root.querySelector('[data-tis-sort-menu]');
    const sortPanel = root.querySelector('[data-tis-sort-panel]');
    const sortTrigger = root.querySelector('[data-tis-sort-open]');
    const active = root.querySelector('[data-tis-filter-active]');
    const drawerActive = root.querySelector('[data-tis-filter-drawer-active]');
    const filterCount = root.querySelector('[data-tis-filter-count]');
    const currentSort = root.dataset.currentSort;
    const visibleCountElement = root.closest('.tis-catalog-toolbar')
      ?.querySelector('[data-tis-catalog-count]');
    const initialCollectionCount = visibleCountElement?.textContent.trim();
    const applyButton = root.querySelector('[data-tis-filter-apply]');
    let countIsFinal = !visibleCountElement?.hasAttribute('data-tis-count-pending');

    const synchronizeCollectionCount = (value, finalize = false) => {
      if (!/^\d+$/.test(value || '')) return;
      root.dataset.productCount = value;
      if (applyButton) applyButton.textContent = 'Show ' + value;
      document.querySelectorAll('[data-tis-load-more-count]').forEach((countElement) => {
        const loadedCount = countElement.dataset.loadedCount;
        if (/^\d+$/.test(loadedCount || '')) {
          countElement.textContent = `${loadedCount} of ${value} products`;
        }
      });
      if (!finalize) return;
      countIsFinal = true;
      visibleCountElement?.removeAttribute('data-tis-count-pending');
      document.querySelectorAll('[data-tis-load-more-count][data-tis-count-pending]')
        .forEach((countElement) => countElement.removeAttribute('data-tis-count-pending'));
    };

    if (/^\d+$/.test(initialCollectionCount || '')) {
      root.dataset.productCount = initialCollectionCount;
      if (applyButton) applyButton.textContent = countIsFinal ? 'Show ' + initialCollectionCount : 'Show products';
      new MutationObserver(() => {
        const updatedCount = visibleCountElement.textContent.trim();
        if (!/^\d+$/.test(updatedCount)) return;
        synchronizeCollectionCount(updatedCount, !countIsFinal && updatedCount !== initialCollectionCount);
      }).observe(visibleCountElement, { childList: true, characterData: true, subtree: true });

      if (countIsFinal) synchronizeCollectionCount(initialCollectionCount);
      else window.setTimeout(() => {
        synchronizeCollectionCount(visibleCountElement.textContent.trim(), true);
      }, 3500);
    }
    let sortCloseTimer;
    let filterCloseTimer;

    const colourRank = (label = '') => {
      const value = label.toLowerCase().trim();
      const priorities = [
        ['black', 'noir'],
        ['white', 'ivory', 'cream', 'off white', 'off-white', 'ecru'],
        ['red', 'scarlet', 'crimson'],
        ['brown', 'chocolate', 'espresso', 'cognac', 'caramel'],
        ['burgundy', 'bordeaux', 'wine', 'oxblood'],
        ['grey', 'gray', 'graphite', 'silver', 'charcoal'],
        ['blue', 'navy', 'cobalt'],
        ['beige', 'camel', 'latte', 'tan', 'nude', 'sand', 'taupe', 'stone', 'natural'],
        ['green', 'olive', 'khaki'],
        ['pink', 'blush', 'rose'],
        ['purple', 'lilac', 'grape', 'violet'],
        ['yellow', 'butter', 'limencello', 'lemon'],
      ];
      const priority = priorities.findIndex((names) => names.some((name) => value.includes(name)));
      return priority === -1 ? 100 : priority;
    };

    root.querySelectorAll('[data-tis-swatch-group]').forEach((group) => {
      const list = group.querySelector('.tis-filter-list');
      if (!list || group.closest('[data-filter-group]')?.dataset.filterGroup === 'Prints') return;
      [...list.querySelectorAll('[data-tis-swatch-option]')]
        .sort((a, b) => {
          const rankDifference = colourRank(a.dataset.filterLabel) - colourRank(b.dataset.filterLabel);
          return rankDifference || a.dataset.filterLabel.localeCompare(b.dataset.filterLabel);
        })
        .forEach((option) => list.append(option));
    });

    const selectedInputs = () => [...root.querySelectorAll('[data-filter-input]')].filter((input) => {
      if (input.type === 'checkbox') return input.checked;
      return input.value.trim() !== '';
    });

    const inputLabel = (input) => {
      const label = input.dataset.filterLabel || input.name;
      return input.type === 'checkbox' ? label : `${label}: ${input.value}`;
    };

    const resetInput = (input) => {
      if (input.type === 'checkbox') input.checked = false;
      else input.value = '';
    };

    const buildSelectionParams = () => {
      const params = new URLSearchParams(new FormData(form));
      [...params.entries()].forEach(([key, value]) => {
        if (!value.trim()) params.delete(key);
      });
      if (currentSort) params.set('sort_by', currentSort);
      return params;
    };

    const buildPersistentParams = () => {
      const params = new URLSearchParams();
      form?.querySelectorAll('[data-tis-persistent-input]').forEach((input) => {
        if (input.name && input.value.trim()) params.append(input.name, input.value);
      });
      return params;
    };

    const navigateWithSelections = () => {
      const params = buildSelectionParams();
      const base = root.dataset.collectionUrl.replace(/\/$/, '');
      window.location.assign(`${base}${params.size ? `?${params}` : ''}`);
    };

    const clearAllFilters = () => {
      const params = buildPersistentParams();
      if (currentSort) params.set('sort_by', currentSort);
      const base = root.dataset.collectionUrl.replace(/\/$/, '');
      window.location.assign(`${base}${params.size ? `?${params}` : ''}`);
    };

    const addActiveChip = (input) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tis-filter-applied__chip';
      chip.textContent = inputLabel(input);
      chip.setAttribute('aria-label', `Remove ${chip.textContent} filter`);
      chip.addEventListener('click', () => {
        resetInput(input);
        navigateWithSelections();
      });
      active.append(chip);
    };

    const addDrawerActiveChip = (input) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tis-filter-drawer-active__chip';
      chip.textContent = inputLabel(input);
      chip.setAttribute('aria-label', `Remove ${chip.textContent} filter`);
      chip.addEventListener('click', () => {
        resetInput(input);
        renderActive();
      });
      drawerActive.append(chip);
    };

    const renderDrawerActive = (selected) => {
      if (!drawerActive) return;
      drawerActive.replaceChildren();
      selected.forEach(addDrawerActiveChip);
      drawerActive.hidden = selected.length === 0;
    };

    const selectedSwatchLabels = (group) => [...group.querySelectorAll('[data-filter-input]:checked')]
      .map((input) => input.dataset.filterLabel)
      .filter(Boolean);

    const setSwatchStatus = (group, temporaryLabel = '') => {
      const status = group.querySelector('[data-tis-swatch-status]');
      if (!status) return;
      const selectedLabels = selectedSwatchLabels(group);
      const text = temporaryLabel || selectedLabels.join(', ');
      status.textContent = text;
      status.title = text;
      status.toggleAttribute('data-has-value', Boolean(text));
    };

    root.querySelectorAll('[data-tis-swatch-group]').forEach((group) => {
      group.querySelectorAll('[data-tis-swatch-option]').forEach((option) => {
        const label = option.dataset.filterLabel || '';
        option.addEventListener('mouseenter', () => setSwatchStatus(group, label));
        option.addEventListener('mouseleave', () => setSwatchStatus(group));
        option.addEventListener('focusin', () => setSwatchStatus(group, label));
        option.addEventListener('focusout', () => setSwatchStatus(group));
      });
      setSwatchStatus(group);
    });

    const renderActive = () => {
      const selected = selectedInputs();
      root.querySelectorAll('[data-filter-input][type="checkbox"]').forEach((input) => {
        input.closest('.tis-filter-list__option')?.classList.toggle('active', input.checked);
      });
      root.querySelectorAll('.tis-filter-accordion').forEach((group) => {
        if (group.querySelector('[data-filter-input]:checked') || [...group.querySelectorAll('input[type="number"]')].some((input) => input.value)) group.open = true;
      });
      if (filterCount) filterCount.textContent = selected.length ? `(${selected.length})` : '';
      root.querySelectorAll('[data-tis-swatch-group]').forEach((group) => setSwatchStatus(group));
      renderDrawerActive(selected);
      if (!active) return;
      active.replaceChildren();
      selected.forEach(addActiveChip);
      if (selected.length) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'tis-filter-applied__clear';
        clear.textContent = 'Clear All';
        clear.addEventListener('click', clearAllFilters);
        active.append(clear);
      }
      active.hidden = selected.length === 0;
    };

    root.querySelectorAll('[data-filter-input]').forEach((input) => input.addEventListener('change', renderActive));
    renderActive();

    const openFilter = () => {
      if (!dialog) return;
      window.clearTimeout(filterCloseTimer);
      dialog.showModal();
      void dialog.offsetWidth;
      dialog.classList.add('is-open');
      document.documentElement.classList.add('tis-filter-open');
    };

    const closeFilter = (restoreFocus = true) => {
      if (!dialog?.open) return;
      dialog.classList.remove('is-open');
      document.documentElement.classList.remove('tis-filter-open');
      filterCloseTimer = window.setTimeout(() => {
        dialog.close();
        if (restoreFocus) filterTrigger?.focus({ preventScroll: true });
      }, 400);
    };

    filterTrigger?.addEventListener('click', openFilter);
    root.querySelector('[data-tis-filter-close]')?.addEventListener('click', closeFilter);
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) closeFilter(); });
    dialog?.addEventListener('cancel', (event) => { event.preventDefault(); closeFilter(); });

    root.querySelector('[data-tis-filter-clear]')?.addEventListener('click', () => {
      root.querySelectorAll('[data-filter-input]').forEach(resetInput);
      clearAllFilters();
    });
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      navigateWithSelections();
    });

    const openSort = () => {
      if (!sortMenu || !sortPanel || !sortTrigger) return;
      window.clearTimeout(sortCloseTimer);
      sortPanel.dataset.tisSortMode = 'modal';
      sortPanel.showModal();
      void sortPanel.offsetWidth;
      sortPanel.classList.add('is-open');
      sortMenu.classList.add('is-open');
      sortTrigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('tis-sort-open');
    };

    const closeSort = (restoreFocus = true) => {
      if (!sortMenu || !sortPanel?.open || !sortTrigger) return;
      sortPanel.classList.remove('is-open');
      sortMenu.classList.remove('is-open');
      sortTrigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('tis-sort-open');
      sortCloseTimer = window.setTimeout(() => {
        sortPanel.close();
        delete sortPanel.dataset.tisSortMode;
        if (restoreFocus) sortTrigger.focus({ preventScroll: true });
      }, 400);
    };

    sortTrigger?.addEventListener('click', () => {
      if (sortMenu?.classList.contains('is-open')) closeSort();
      else openSort();
    });
    root.querySelectorAll('[data-tis-sort-close]').forEach((button) => button.addEventListener('click', closeSort));
    sortPanel?.addEventListener('click', (event) => { if (event.target === sortPanel) closeSort(); });
    sortPanel?.addEventListener('cancel', (event) => { event.preventDefault(); closeSort(); });
    root.querySelectorAll('[data-tis-sort]').forEach((button) => {
      button.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', button.dataset.tisSort);
        window.location.assign(`${window.location.pathname}?${params}`);
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sortMenu?.classList.contains('is-open')) {
        event.preventDefault();
        closeSort();
      }
    });
    window.addEventListener('resize', () => {
      if (sortMenu?.classList.contains('is-open')) closeSort(false);
    });
  });
})();
